import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import { DEFAULT_PAGE_SIZE } from '../../constants/generic'
import { formatVod } from '../vods/vods.format'
import { formatVodBundle } from './vodBundles.format'

export function use(
  client: WbsClient,
  vodBundles: API['vodBundles'],
  _api: API,
  defaults: AdapterDefaults
): void {
  // GET /v3/bundles/vods
  vodBundles.getVodBundlesFx.use(
    async ({
      page,
      sortBy,
      sortOrder = defaults.sortOrder,
      count = defaults.count || DEFAULT_PAGE_SIZE,
    }) => {
      const bundles = await payload(
        client.get.api.v3.bundles.vods({
          query: {
            page: page || undefined,
            count: count || undefined,
            'sort-by': sortBy || undefined,
            'sort-order': sortOrder || undefined,
          },
        })
      )
      return {
        ...bundles,
        content: bundles.content.map(formatVodBundle),
      }
    }
  )

  // GET /v3/bundles/vods/{bundleId}
  vodBundles.getVodBundleInfoBaseFx.use(async ({ bundleId }) => {
    const bundle = await payload(client.get.api.v3.bundles.vods(bundleId)())
    return formatVodBundle(bundle)
  })

  // GET /v3/bundles/vods/{id}/content
  vodBundles.getVodBundleContentFx.use(
    async ({ bundleId, page, count = defaults.count || DEFAULT_PAGE_SIZE }) => {
      const vods = await payload(
        client.get.api.v3.bundles.vods(bundleId).content({
          query: { page: page || undefined, count: count || undefined },
        })
      )

      return {
        ...vods,
        content: vods.content.map(formatVod),
      }
    }
  )

  /**************** $VodBundleWithContent *******************/
  // to paginate over - paginateTvBundleWithContent
  vodBundles.loadVodBundleWithContentFx.use(async ({ count, bundleId }) => {
    const bundleInfo = await vodBundles.loadVodBundleInfoForContent({
      bundleId,
    })
    const vods = [
      ...(
        await vodBundles.paginateVodBundleWithContent({
          page: 0,
          count,
          bundleId: Number(bundleId),
        })
      ).content,
    ]

    return {
      ...bundleInfo,
      vods,
    }
  })
  /**************** $VodBundleWithContent *******************/
}
